<table>
  <thead>
    <th>No.</th>
    <th>State</th>
    <!-- <th>State Registration No.</th> -->
    <!-- <th>Date of Registration</th> -->
    <th>License</th>
    <th>License No.</th>
  </thead>
  <tbody class="licenseTBody">
    <tr *ngFor="let licensure of sortByNo(licensures.data); let idx = index">
      <td>{{ licensure.attributes.no }}</td>
      <td>{{ getState(licensure.attributes.registrationState, licensure.attributes.mobileStateDif) }}</td>
      <!-- <td>
        <div [hidden]="!license.registrationStateNo" *ngFor="let license of licensure.attributes.license" class="">
          {{ license.registrationStateNo }}
        </div>
      </td> -->
      <!-- <td>
        <div *ngFor="let license of licensure.attributes.license" class="">
          {{ transformDateFormat(license.dateOfRegistration, licensure.attributes.license.additionalDate) }}
        </div>
      </td> -->
      <td>
        <div *ngFor="let license of licensure.attributes.license" class="">
          {{ transformSpaces(license.license) }}
        </div>
      </td>
      <td>
        <div
          (click)="openLicense(license.hasLicensureImg, license.licensureImg, licensure.attributes.registrationState)"
          [ngClass]="{ licenseLink: license.hasLicensureImg }"
          *ngFor="let license of licensure.attributes.license"
          class=""
        >
          {{ transformSpaces(license.licenseNumber) }}
        </div>
      </td>
    </tr>
  </tbody>
</table>
